import { render, staticRenderFns } from "./wsSidebarChat.vue?vue&type=template&id=637d85e1&scoped=true&"
import script from "./wsSidebarChat.vue?vue&type=script&lang=js&"
export * from "./wsSidebarChat.vue?vue&type=script&lang=js&"
import style0 from "./wsSidebarChat.vue?vue&type=style&index=0&id=637d85e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637d85e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VDivider,VHover,VIcon,VSheet})
